import React from 'react';
import style from './style.scss';
import {DateTime} from 'components/UI/DateTime';
import {Link} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';

class EasyNeedOffer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="easy-need-offer">
        <div className='easy-need-offer-left-content'>
          <UploadImage transform="crop" className='product-image' width="68" height="68" type="USER" image={this.props.user.businesses && this.props.user.businesses.length > 0
            ? this.props.user.businesses[0].logo
            : this.props.user.avatar}/>
        </div>
        <div className='easy-need-offer-right-content'>
          <p className='description'>{this.props.content}</p>
          <div className='content-justify'>
            <h2 className='title'>
              {this.props.user
                ? (this.props.user.businesses && this.props.user.businesses.length > 0
                  ? (
                    <Link to={`business/${this.props.user.businesses[0].id}`}>{this.props.user.businesses[0].name}</Link>
                  )
                  : (this.props.user.fullname))
                : (null)}
            </h2>
            <p className='time'><i className='vtd-calendar'/><DateTime dateTime={this.props.updatedAt}/></p>
          </div>
        </div>
      </div>
    );
  }
}

export default EasyNeedOffer;



// WEBPACK FOOTER //
// ./components/partials/easy-need-offer/EasyNeedOffer.jsx